import { getFormInitialValues } from 'redux-form';
import { getState } from '../store/store';

const getFormDefaultValue = (fieldConfig = {}) => {
  switch (fieldConfig.type) {
    case 'bool':
      return false;
    default:
      return '';
  }
};

const getFormDefinedValue = (field, fieldConfig = {}) => {
  if (!field) return '';

  const { value } = field;
  if (typeof value === 'undefined') return null;

  const stringValue = String(value);
  const type = fieldConfig.apiType || fieldConfig.type;

  switch (type) {
    case 'number':
      return stringValue;

    default:
      return value;
  }
};

const getFormValue = (field, fieldConfig = {}) => {
  if (!field) return null;

  if (field.value === null) {
    return getFormDefaultValue(fieldConfig);
  }

  return getFormDefinedValue(field, fieldConfig);
};

const getFormValues = (fields, fieldsConfig = {}) => {
  if (!fields) return {};

  const formValues = {};

  if (Array.isArray(fields)) {
    fields.forEach(field => {
      formValues[field.id] = getFormValue(field, fieldsConfig[field.id]);
    });
  } else {
    Object.keys(fields).forEach(fieldId => {
      formValues[fieldId] = getFormValue(
        {
          ...fields[fieldId],
          id: fieldId
        },
        fieldsConfig[fieldId]
      );
    });
  }

  if (fieldsConfig.mapConfig && fieldsConfig.mapConfig.getFormValues) {
    return fieldsConfig.mapConfig.getFormValues(formValues);
  }

  return formValues;
};

const getApiDefinedValue = (field, fieldConfig = {}) => {
  if (!field) return undefined;

  const { value } = field;

  if (typeof value === 'undefined') return null;
  if (value === null) return null;
  if (field.hasError) return null;

  const type = fieldConfig.apiType || fieldConfig.type;
  switch (type) {
    case 'bool': {
      return value;
    }
    case 'number': {
      const numberValue = parseFloat(value);
      return !Number.isNaN(numberValue) || numberValue === 0
        ? numberValue
        : null;
    }
    case 'phone': {
      return value
        .split('')
        .filter(symbol => !['(', ')', '-', ' ', '_'].includes(symbol))
        .join('');
    }
    case 'text': {
      return String(value).trim() || null;
    }
    default:
      return value || null;
  }
};

const getApiValue = (field, fieldConfig = {}) => {
  if (!field) return undefined;

  if (typeof field.visible !== 'undefined' && !field.visible) return undefined;
  if (typeof field.disabled !== 'undefined' && field.disabled) return undefined;

  return getApiDefinedValue(field, fieldConfig);
};

const getApiValues = (fields, values, fieldsConfig = {}, errors = {}) => {
  if (!fields) return {};

  const apiValues = {};

  const fieldsConfigValues =
    fieldsConfig.mapConfig && fieldsConfig.mapConfig.getApiValues
      ? fieldsConfig.mapConfig.getApiValues(values)
      : values;

  if (Array.isArray(fields)) {
    fields.forEach(field => {
      const value = getApiValue(
        {
          ...field,
          value: fieldsConfigValues
            ? fieldsConfigValues[field.id]
            : field.value,
          hasError: errors[field.id]
        },
        fieldsConfig[field.id]
      );

      if (typeof value !== 'undefined') {
        apiValues[field.id] = { value };
      }
    });
  } else {
    Object.keys(fields).forEach(fieldId => {
      const field = fields[fieldId];
      const value = getApiValue(
        {
          ...field,
          id: fieldId,
          value: fieldsConfigValues ? fieldsConfigValues[fieldId] : field.value,
          hasError: errors[fieldId]
        },
        fieldsConfig[fieldId]
      );
      if (typeof value !== 'undefined') {
        apiValues[fieldId] = { value };
      }
    });
  }

  return apiValues;
};

const getChangedFormValues = (formId, formValues) => {
  if (!formValues) return null;
  const formInitialValues = getFormInitialValues(formId)(getState());

  const changedFormValues = {};

  Object.keys(formValues).forEach(key => {
    if (formValues[key] !== formInitialValues[key]) {
      changedFormValues[key] = formValues[key];
    }
  });

  return changedFormValues;
};

const FormUtils = {
  getFormDefaultValue,

  getFormValue,
  getFormValues,

  getApiValue,
  getApiValues,

  getChangedFormValues
};

export default FormUtils;



// WEBPACK FOOTER //
// ./src/utils/formUtils.js